import { TrendingUp, DollarSign } from "lucide-react";
import {
  PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
  ResponsiveContainer, AreaChart, Area,
} from "recharts";
import { CHART } from "../../../lib/constants";
import {
  CHART_HEIGHT, PIE_INNER, PIE_OUTER, AXIS_TICK, AXIS_STROKE, GRID_STROKE, TOOLTIP_STYLE,
} from "../lib/chartTokens";

const MONTHS = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const formatMonth = (v) => {
  if (!v) return "";
  const [y, m] = v.split("-");
  return m === "01" ? y : `${MONTHS[parseInt(m)]} '${y.slice(2)}`;
};

export const TrendMonetizationRow = ({ trendData, monetizationData }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
    <div className="bg-card border border-border rounded-xl p-5">
      <h3 className="text-base font-semibold mb-4 flex items-center gap-2">
        <TrendingUp className="w-4 h-4 text-primary" />
        Monthly Launch Trend
      </h3>
      <div className={CHART_HEIGHT}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={trendData}>
            <CartesianGrid strokeDasharray="3 3" stroke={GRID_STROKE} />
            <XAxis
              dataKey="month"
              stroke={AXIS_STROKE}
              tick={AXIS_TICK}
              interval={5}
              tickFormatter={formatMonth}
            />
            <YAxis stroke={AXIS_STROKE} tick={AXIS_TICK} />
            <Tooltip {...TOOLTIP_STYLE} />
            <Area type="monotone" dataKey="count" stroke="#8b5cf6" fill="url(#colorGradient)" />
            <defs>
              <linearGradient id="colorGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#8b5cf6" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#8b5cf6" stopOpacity={0} />
              </linearGradient>
            </defs>
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>

    <div className="bg-card border border-border rounded-xl p-5">
      <h3 className="text-base font-semibold mb-4 flex items-center gap-2">
        <DollarSign className="w-4 h-4 text-primary" />
        Monetization Models
      </h3>
      <div className={CHART_HEIGHT}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={monetizationData}
              cx="50%"
              cy="50%"
              innerRadius={PIE_INNER}
              outerRadius={PIE_OUTER}
              paddingAngle={2}
              dataKey="value"
            >
              {monetizationData.map((entry) => (
                <Cell key={`cell-${entry.name}`} fill={entry.fill} />
              ))}
            </Pie>
            <Tooltip {...TOOLTIP_STYLE} />
            <Legend wrapperStyle={CHART.legend} />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  </div>
);

export default TrendMonetizationRow;
